(function () {
  function initFeaturedPcs(section) {
    if (!section || section.dataset.homeFeaturedInit === 'true') return;
    section.dataset.homeFeaturedInit = 'true';

    var tabs = section.querySelectorAll('[data-home-featured-tab]');
    var panels = section.querySelectorAll('[data-home-featured-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-home-featured-tab');
        if (!target) return;

        tabs.forEach(function (btn) {
          var isActive = btn.getAttribute('data-home-featured-tab') === target;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-home-featured-panel') === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="home-featured-pcs"]').forEach(initFeaturedPcs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="home-featured-pcs"]');
    if (section) initFeaturedPcs(section);
  });
})();
